import { BooleanRadioButton, BooleanRadioButtonGroup, ExternalLink } from "@octopusdeploy/design-system-components";
import type { DeploymentProcessResource, ProjectResource, DeploymentActionPackageResource } from "@octopusdeploy/octopus-server-client";
import type React from "react";
import { Note } from "~/components/form";
import { ReleaseVersionFromPackageSelector } from "./ReleaseVersionFromPackageSelector";
import { ReleaseVersionTemplateInput } from "./ReleaseVersionTemplateInput";
import type { DeploymentSettingsModel } from "./SharedDeploymentSettingsPage";
interface ReleaseVersioningProps {
    project: ProjectResource;
    setModelProp: <K extends keyof DeploymentSettingsModel>(model: Pick<DeploymentSettingsModel, K>) => void;
    versioningStrategyTemplate: string;
    versionFromPackage: boolean;
    versioningStrategyPackage: DeploymentActionPackageResource | undefined;
    versionPackageActions: DeploymentActionPackageResource[];
    deploymentProcess: DeploymentProcessResource | undefined;
}
export const ReleaseVersioning: React.FC<ReleaseVersioningProps> = (props: ReleaseVersioningProps) => (<>
        <BooleanRadioButtonGroup accessibleName="release versioning strategy" value={props.versionFromPackage} onChange={(versionFromPackage) => props.setModelProp({ versionFromPackage })}>
            <BooleanRadioButton value={false} label="Generate version numbers using a template" isDefault={true}/>
            <BooleanRadioButton value={true} label="Use the version number from an included package"/>
        </BooleanRadioButtonGroup>

        <Note>
            This setting controls the default version given to new releases.
            <br />
            The version can be generated from a template containing variable-expressions, or using the version from a package used by the deployment process.
            <br />
            See the <ExternalLink href="ReleaseVersioning">documentation</ExternalLink> for more information.
        </Note>

        {props.versionFromPackage ? (<ReleaseVersionFromPackageSelector deploymentProcess={props.deploymentProcess} setModelProp={props.setModelProp} versioningStrategyPackage={props.versioningStrategyPackage} versionPackageActions={props.versionPackageActions}/>) : (<ReleaseVersionTemplateInput setModelProp={props.setModelProp} versioningStrategyTemplate={props.versioningStrategyTemplate}/>)}
    </>);
ReleaseVersioning.displayName = "ReleaseVersioning"
